import { formatMoney } from "@/features/cost-allocations/utils/formatMoney";

type Props = {
  monthDepreciation: string;
  accumulatedDepreciation: string;
  remainingBookValue: string;
  isLoading: boolean;
};

export function DepreciationSummary({
  monthDepreciation,
  accumulatedDepreciation,
  remainingBookValue,
  isLoading,
}: Props) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
      <SummaryCard label="Depreciación del mes" value={monthDepreciation} isLoading={isLoading} />
      <SummaryCard
        label="Depreciación acumulada"
        value={accumulatedDepreciation}
        isLoading={isLoading}
      />
      <SummaryCard label="Valor en libros" value={remainingBookValue} isLoading={isLoading} />
    </div>
  );
}

function SummaryCard({
  label,
  value,
  isLoading,
}: { label: string; value: string; isLoading: boolean }) {
  return (
    <div className="rounded-2xl border border-app-border bg-app-surface p-4">
      <p className="font-medium text-[11px] text-app-ink-3 uppercase tracking-[0.06em]">{label}</p>
      <div className="mt-2">
        {isLoading ? (
          <div className="h-7 w-32 animate-pulse rounded bg-app-border" />
        ) : (
          <span className="font-semibold text-[20px] text-app-ink-1 tabular-nums">
            {formatMoney(value)}
          </span>
        )}
      </div>
    </div>
  );
}
